<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Tasks</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <div>
              apakah anda yakin untuk completed task ini ?
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="confirm">
          Yes
        </v-btn>
        <v-btn color="error" @click="close">
          No
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-complete",
  props: {
    dialog: Boolean,
    item: Object,
  },
  methods: {
    confirm() {
      this.$emit("complete", this.item);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style></style>
